import { render } from "./SalesWizardRecommendations.vue?vue&type=template&id=4f741c62"
import script from "./SalesWizardRecommendations.vue?vue&type=script&lang=js"
export * from "./SalesWizardRecommendations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__